import LazoFileService from "@/services/LazoFileService";
import { useQuery } from "@tanstack/react-query";

export const LAZO_FILE_QUERY_KEY = "lazo-file";

// ========== QUERIES ==========

export function useLazoFilePreSignedUrl(fileExternalId: string | undefined, enabled: boolean = true) {
  return useQuery({
    queryKey: [LAZO_FILE_QUERY_KEY, "pre-signed-url", fileExternalId],
    queryFn: () => LazoFileService.generatePreSignedUrl(fileExternalId!).then((r) => r.getContentOrThrowError()),
    enabled: !!fileExternalId && enabled,
    staleTime: Infinity, // URL is fetched into memory as blob immediately, expiry is irrelevant
    gcTime: 5 * 60 * 1000,
    meta: {
      errorMessage: "Error generating file URL",
    },
  });
}
